@if (loading) {
<spinner-overlay [fullscreen]="true"></spinner-overlay>
}
<app-menu [organisation]="organisation" [linqset]="linqset" [screen]="screen" (menuEvent)="handleFunctionEvent($event)"></app-menu>
<app-analysis-header [organisation]="organisation" [view]="view"></app-analysis-header>

@if (isHelpOn()) {
<div class="hint">
    @if (view === 'tags') {
    How the work you're looking at splits between the tags of each tag group, and which actions carry each tag. Pick a
    group, then a tag, to see its actions; click an action to open it in its model.
    } @else if (view === 'information') {
    The outputs of what you're looking at as information assets. Each carries a value: one a user set, or one LINQ
    derived from how the output is used (0 to 100 across the organisation). See what the derived values rest on,
    where the value lands, and the friction behind the outputs nothing uses. Pick an output to see what produces and
    uses it, and set its value from LINQ's or AI's suggestion.
    } @else if (view === 'insights') {
    The insights overview of what you're looking at: the figures, top fives and charts for each part of it. Choose
    the sections and attributes to show, download it as a PDF or view it as a carousel.
    } @else if (view === 'ai') {
    A written summary of what you're looking at, by AI. Choose or write a prompt, generate it, and save it to come back to.
    } @else {
    Every node in what you're looking at, by type. Pick a type to see its nodes with their figures; the columns can be
    chosen and the table exported.
    }
</div>
}

<div class="nodes" data-testid="nodes-view">
    @if (error) {
    <p class="error" role="alert">{{ error }}</p>
    } @else if (linqset) {
    <header class="intro">
        <h2>{{ view === 'ai' ? 'AI summary' : view === 'insights' ? 'Insights' : view === 'tags' ? 'Tags' : view === 'information' ? 'Information' : 'Nodes' }} · {{ description }}</h2>
    </header>
    @if (view === 'tags') {
    <app-tags-analysis id="analysis-view-main" [linqset]="linqset" [organisationLinqset]="organisationLinqset" [trigger]="reloadTrigger"></app-tags-analysis>
    } @else if (view === 'information') {
    <app-information-analysis id="analysis-view-main" [linqset]="linqset" [organisationLinqset]="organisationLinqset" [trigger]="reloadTrigger"
        [comparison]="comparison" [comparisonOrganisationLinqset]="comparison ? currentStateOrganisationLinqset : undefined" (valuesApplied)="reload()"></app-information-analysis>
    } @else if (view === 'insights') {
    <div id="analysis-view-main" class="insights"><app-insights-overview [linqset]="linqset" [comparison]="comparison" [trigger]="reloadTrigger"></app-insights-overview></div>
    } @else if (view === 'ai') {
    <div id="analysis-view-main" class="ai"><app-query-ai [linqset]="linqset"></app-query-ai></div>
    } @else {
    <app-node-table id="analysis-view-main" [linqset]="linqset" [trigger]="reloadTrigger" [comparison]="comparison" [organisationLinqset]="organisationLinqset" [isGrouped]="false" [multiSelect]="false"></app-node-table>
    }
    }
</div>
